<template>
	<b-container fluid>
		<page-title><h2><router-link :to="{ name: 'DebtorList' }" class="nav-link">Dłużnicy</router-link>/<span v-if="item && !loading">{{ item['name'] }}</span></h2>
			<div v-if="item && !loading" class="page-title__buttons">
				<router-link :to="{name: 'DebtorUpdate', params: { id: item.id }}" title="Edytuj" class="btn btn-default"><span>Edytuj</span><svg-icon name="edit"/></router-link>
			</div>
		</page-title>

		<div class="col page-element">
			<alert-loading v-if="loading"></alert-loading>
			<div v-if="error" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ error }}</div>
			<div v-if="deleteError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ deleteError }}</div>

			<div v-if="item && !loading" class="row">
				<div class="col-md-6">
					<table class="table table-data">
						<tbody>
							<tr>
								<td>Nazwa</td>
								<td>{{ item['name'] }}</td>
							</tr>
							<tr>
								<td>NIP</td>
								<td>{{ item['nip'] }}</td>
							</tr>
							<tr>
								<td>REGON</td>
								<td>{{ item['regon'] }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="col-md-6">
					<table class="table table-data">
						<tbody>
							<tr>
								<td>Adres</td>
								<td>{{ item.address.postalCode }} {{ item.address.city }}, ul. {{ item.address.street }} {{ item.address.number }}</td>
							</tr>
							<tr>
								<td>Zgoda na cesję</td>
								<td v-if="item.cessionAvailable">TAK</td>
								<td v-if="!item.cessionAvailable">NIE</td>
							</tr>
							<tr v-if="item.comments">
								<td>Uwagi</td>
								<td>{{ item['comments'] }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>

		<debtor-document-list v-if="item && !loading" :id="item['id']"></debtor-document-list>
		<invoice-list v-if="item && !loading" :id="item['id']"></invoice-list>
  </b-container>
</template>

<script>
  import { mapGetters } from 'vuex';
  import InvoiceList from './InvoiceList.vue'

  export default {
    computed: mapGetters({
      deleteError: 'debtor/del/error',
      error: 'debtor/show/error',
      loading: 'debtor/show/loading',
      item: 'debtor/show/item',
    }),
    components: {
      'invoice-list': InvoiceList
    },
    methods: {
      deleteItem (item) {
        if (window.confirm('Czy na pewno chce usunąć tego dłużnika?'))
          this.$store.dispatch('debtor/del/delete', item).then(response => this.$router.push({ name: 'DebtorList' }));
      }
    },
    created () {
      this.$store.dispatch('debtor/show/retrieve', this.$route.params.id);
    },
    beforeDestroy() {
      this.$store.dispatch('debtor/show/reset');
    }
  }
</script>



// WEBPACK FOOTER //
// Show.vue?070e0df3